import styled from "styled-components";
import { Small } from "@/lib/styles";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: calc(50% - 2rem);
  margin-top: 1.5rem;
  padding: 0 1rem;

  &:nth-of-type(1),
  &:nth-of-type(2) {
    margin-top: 0.5rem;
  }

  & #tooltip-info {
    display: inline-block;
    width: fit-content;
    cursor: pointer;
  }
`;

export const Label = styled.span<{ $isEco?: boolean }>`
  display: block;
  text-transform: uppercase;
  color: ${({ $isEco, theme }) =>
    $isEco ? theme.colors.white : theme.colors.darkMiddle};
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
`;

export const Value = styled(Small)<{ $isEco?: boolean }>`
  display: flex;
  margin-top: 0.5rem;
  line-height: 1.6;
  font-weight: 700;
  text-transform: capitalize;
  color: ${({ $isEco, theme }) =>
    $isEco ? theme.colors.white : theme.colors.black};
`;

export const Wrapper = styled.div<{ $isEco?: boolean; $index?: number }>`
  width: fit-content;
  padding: 0.5rem;
  border-radius: 0.125rem;
  background-color: ${({ $isEco, theme }) =>
    $isEco ? theme.colors.greenEco : "none"};
`;
